export const LONGEST_RECORDED_HUMAN_LIFE_IN_YEARS = 122;
export const MINIMUM_SIGNUP_AGE = 13;
export const MOBILE_MAX_WIDTH_SIGNUP = '420px';
